<template>
  <IconLucideImageUp />
</template>
